import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import * as ResourceApi from 'api/resources';
import {resourcesSelector} from 'resources/selectors';
import {UserGroups, RestrictedUserGroups} from 'utils/DBUtils';
import ViewAllPlatformsPage from './ViewAllPlatformsPage';
import AddStepsModalContainer from './AddSteps/AddStepsModalContainer';
import DeleteStepsModalContainer from './DeleteSteps/DeleteStepsModalContainer';
import {synchronizeResourceAction} from 'resources/actions';
import {startCopyChallengeAction} from "pages/BreakCopy/actions";
import CopyBreakModalContainer from 'pages/BreakCopy/CopyBreakModalContainer';
import {startAddStepsAction, startDeleteStepsAction, togglePublishStepAction} from './actions';
import {startPublishChallengeAction, startValidateChallengeAction} from "pages/BreakPublish/actions";
import {getUserResourceActions, getUserServiceActions} from 'pages/Profile/selectors';
import {startUnpublishChallengeAction} from "../BreakPublish/actions";
import {saveResourceFieldAction} from "../../resources/actions";

const getAnalyticsResourceActions = getUserResourceActions(ResourceApi.Types.Analytics);
const getBreakResourceActions = getUserResourceActions(ResourceApi.Types.Break);
const getBreakServiceActions = getUserServiceActions(ResourceApi.Types.PublishedBreak);

const mapStateToProps = state => {
  const brk = get(state.editBreak, 'break', null);

  if (isEmpty(brk)) {
    return {
      break: null,
      resourceId: null
    };
  } else {
    const resources = resourcesSelector(state.resources);
    const breaksByPlatform = Object.keys(brk).reduce((breaks, key) => {
      const id = brk[key];
      breaks[key] = get(resources, id, null);
      return breaks;
    }, {});

    const { savingStepOrder } = state.viewAllPlatforms;

    const userCanViewAnalytics = includes(getAnalyticsResourceActions(state), 'READ');

    const userCanDeleteBreaks = includes(getBreakResourceActions(state), 'DELETE');

    const breakServiceActions = getBreakServiceActions(state);
    const userCanPublishBreaks = includes(breakServiceActions, 'PUBLISH_BREAK');
    const userCanUnpublishBreaks = includes(breakServiceActions, 'UNPUBLISH_BREAK');

    return {
      userCanViewAnalytics,
      userCanDeleteBreaks,
      userCanPublishBreaks,
      userCanUnpublishBreaks,
      break: breaksByPlatform,
      masterResourceId: resources[brk.MASTER].resourceId,
      savingStepOrder,
      challengeIsPublishing: state.publishChallenge.publishingChallenge,
      platformsBeingPublished: state.publishChallenge.platformsBeingPublished,
      challengeIsValidating: state.publishChallenge.validatingChallenge,
      platformsBeingValidated: state.publishChallenge.platformsBeingValidated,
        challengeIsUnpublishing: state.publishChallenge.unpublishingChallenge,
        platformsBeingUnpublished: state.publishChallenge.platformsBeingUnpublished
    };
  }
};

const mapDispatchToProps = dispatch => bindActionCreators({
  togglePublishStep: togglePublishStepAction,
  saveStepNumbers: (breakId, newStepOrder) => {
    return saveResourceFieldAction(
        breakId,
        breakId,
        [],
        ['breakStepsOrder'],
        'breakStepsOrder',
        newStepOrder,
        [breakId],
        [],
        [],
        false,
    );
  },
  syncMaster: synchronizeResourceAction,
  openAddStepsModal: startAddStepsAction,
  openDeleteStepsModal: startDeleteStepsAction,
  showCopyBreakModal: (masterId, permalink) => startCopyChallengeAction(masterId, permalink),
  publishChallenge: (challenge, platforms, brk) => startPublishChallengeAction(challenge, platforms, brk),
  validateChallenge: (challenge, platforms, brk) => startValidateChallengeAction(challenge, platforms, brk),
    unpublishChallenge: (challenge, platforms, brk) => startUnpublishChallengeAction(challenge, platforms, brk)
}, dispatch);

const ViewAllPlatformsPageConnected = connect(mapStateToProps, mapDispatchToProps);

const ViewAllPlatformsPageWithHandlers = withHandlers({
  syncMaster: props => platform => props.syncMaster(platform, props.masterResourceId)
});

const ViewAllPlatformsPageComposed = compose(
  ViewAllPlatformsPageConnected,
  ViewAllPlatformsPageWithHandlers
)(ViewAllPlatformsPage);

const ViewAllPlatformsPageContainer = routeProps => [
  <ViewAllPlatformsPageComposed {...routeProps} key='ViewAllPlatformsPage' />,
  <AddStepsModalContainer key='AddStepsModal' />,
  <DeleteStepsModalContainer key='DeleteStepsModal' />,
  <CopyBreakModalContainer key="CopyBreakModal"/>
];

export default ViewAllPlatformsPageContainer;



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/ViewAllPlatformsPageContainer.js